import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getCurrentRegion, getOrderNumber, getOrderNumberUuid, getPayUrl, getBillCreated} from "../../store/order";
import {buyForOrder, changeOrder} from "../../store/order";
import * as yup from "yup";
import {ArrowPathIcon} from "@heroicons/react/24/outline";
import {getOrderByShopAndRegion} from "../../store/order/actions";
import OrderStatusChecker from "./orderStatusChecker";

function ShopCartTotal({ cart }) {
  const currentRegion = useSelector(getCurrentRegion());
  const dispatch = useDispatch();
  const orderNumber = useSelector(getOrderNumber());
  const payUrl = useSelector(getPayUrl());
  const orderNumberUuid = useSelector(getOrderNumberUuid());
  const billCreated = useSelector(getBillCreated());
  const [data, setData] = useState("");
  const [emailChanged, setEmailChanged] = useState(false);
  let warningMessage = '';
  let showWarning = false;
  if (!cart.userEmail || emailChanged) {
    warningMessage = 'Перед покупкой укажите свой email. На него будут отправлены счёт и коды после оплаты.';
    showWarning = true;
  } else if (cart.finalSum < 1) {
    warningMessage = 'Выберите товар для покупки.';
    showWarning = true;
  }
  useEffect(() => {
    setData(cart.userEmail);
    setEmailChanged(false);
    setError(null);
  }, [cart]);
  const [error, setError] = useState(null);
  const schema = yup.object().shape({
    email: yup
      .string()
      .matches(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        "Введите корректную почту"
      ),
  });
  const handleChange = (e) => {
    if (e.target.value !== "") {
      schema
        .validate({ email: e.target.value })
        .then((r) => {
          setError(null);
        })
        .catch((r) => setError(r.message));
    } else {
      setError('Введите почту');
    }
    setEmailChanged(true);

    setData(e.target.value);
  };
  const handleEmail = () => {
    dispatch(
      changeOrder({
        orderNumberUuid,
        email: data,
      })
    );
    setEmailChanged(false)
  };
  const handleBuy = (e) => {
    e.preventDefault();
    window.ym(93997310, "reachGoal","clickBuyEshop");
    dispatch(buyForOrder({ orderNumberUuid }));
  };

  const clearOrder = () => {
    dispatch(
      getOrderByShopAndRegion("eshop", {
        params: { regionType: currentRegion, createOrder: true },
      })
    );
  };
  return (
    <div className="shop-summary-card relative my-2 flex flex-col items-center">
      <ArrowPathIcon
        className=" absolute right-2 top-2 h-7 w-7 cursor-pointer rounded-full bg-blue-600 p-1 text-white shadow-md transition-all duration-300 hover:bg-blue-700 hover:scale-110"
        onClick={() => clearOrder()}
        title="Пересоздать заказ"
      />
      <div className=" mb-2 flex flex-col items-center justify-between gap-2">
        <div className=" flex flex-col items-center gap-0">
          <span className=" totalTitle">Заказ:</span>
          <span className=" totalTitle"># {orderNumber}</span>
          <span className=" totalText">{cart.caption}</span>
        </div>
        <div className=" flex flex-col items-center gap-0">
          <span className=" totalTitle">Сумма:</span>
          <span className=" totalText">{cart.originalSumText}</span>
        </div>
        <div className=" flex flex-col items-center gap-0">
          <span className=" totalTitle">Персональная скидка:</span>{" "}
          <span className=" totalText">{cart.personalDiscount}</span>
        </div>
        <div className=" flex flex-col items-center gap-0">
          <span className=" totalTitle">Всего к оплате:</span>{" "}
          <span className=" totalText">{cart.finalSumText}</span>
        </div>
      </div>

      <form
        className=" flex w-full flex-col items-center gap-0"
        onSubmit={handleBuy}
      >
        {true && (
          <span
            className={
              " mb-2 w-full overflow-hidden text-xs text-red-600 transition-all duration-300 " +
              (error ? " opacity-1 " : "  invisible opacity-0  ")
            }
          >
            {error}
          </span>
        )}
        <input
          type="text"
          className={
            "mx-2 mb-2 w-full rounded-md border border-gray-400 bg-white px-3 py-1.5 text-black placeholder-gray-600 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 dark:border-gray-600 dark:bg-gray-900 dark:text-white dark:placeholder-gray-400" +
            (billCreated
              ? " cursor-not-allowed bg-gray-100 text-gray-500 placeholder-gray-400 focus:border-gray-400 focus:ring-0 dark:bg-gray-800 dark:text-gray-500 dark:placeholder-gray-600"
              : "")
          }
          placeholder="Ваш email"
          value={data}
          onChange={(e) => handleChange(e)}
          disabled={billCreated}
        />
        <button
          className="shop-action-button mx-2 mb-2 w-full"
          type="button"
          onClick={() => handleEmail()}
          disabled={!!error || !emailChanged || billCreated}
        >
          Загрузить персональную скидку
        </button>
        {showWarning && (
          <span className=" mb-2 w-full overflow-hidden text-xs text-red-600 transition-all duration-300 ">
              {warningMessage}
            </span>
        )}
        <button
          className={
            "mx-2 mt-2 w-full " +
            (!cart.userEmail || emailChanged || cart.finalSum < 1 || billCreated
              ? "shop-action-button shop-action-button-muted"
              : "shop-action-button shop-action-button-green")
          }
          disabled={!cart.userEmail || emailChanged || cart.finalSum < 1 || billCreated}
        >
          Купить
        </button>
        <div className="mb-3 w-full text-center">
          <div className="text-sm text-red-600">
            ❗️🚨<b>Проверяйте папку СПАМ</b>🚨❗️
          </div>
          <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            или вернитесь сюда для получения кодов
          </div>
        </div>
      </form>
      
      { billCreated && (
        <OrderStatusChecker
          orderNumberUuid={orderNumberUuid} 
          userEmail={cart.userEmail} 
        />
      )}
    </div>
  );
}

export default ShopCartTotal;
